<template>
  <donation-purpose-card
    :purpose="props.donationInitiative"
    :name="initiativeName"
    :query="{ initiativeName: initiativeName }"
    :featured="props.donationInitiative.isFeatured === true"
  />
</template>
<script lang="ts" setup>
import type { DonationInitiative } from "@/composables/donations/useDonationNew";
import DonationPurposeCard from "./DonationPurposeCard.vue";
const props = defineProps<{ donationInitiative: DonationInitiative }>();
const initiativeName = computed(
  () => props.donationInitiative.initiativeName!!,
);
</script>
